import { useMemo } from "react";
import type { ColumnDef } from "@tanstack/react-table";
import { Maximize2 } from "lucide-react";
import { UserType } from "@repo/types/enums";
import { type UserDTO } from "@repo/types/dtos";
import { UserColumns } from "@repo/helpers";
import { buildColumn } from "../helpers/columnBuilder";
import { useFormatDate } from "../../helpers/useFormatDate";
import { type RecordProps } from "@repo/types/ui/tables";
//import TruncatedText from "../../components/ui/TruncatedText";

const useUserColumns = ({
  onOpenRecord: onOpenUser,
  //onUpdateRecord: onUpdateUser,
}: RecordProps): ColumnDef<UserDTO>[] => {
  const { formatDate } = useFormatDate();

  const columns = useMemo<ColumnDef<UserDTO>[]>(
    () => [
      buildColumn<UserDTO>(UserColumns.FullName, {
        size: 200,
        enablePinning: false,
        cell: ({ row }) => (
          <button
            onClick={() => onOpenUser(row.original.UserGuid)}
            className="group flex items-center gap-2"
          >
            {/* <TruncatedText text={row.original.FullName} maxLength={40} /> */}

            <Maximize2
              className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 cursor-pointer"
              size={15}
            />
          </button>
        ),
      }),
      buildColumn<UserDTO>(UserColumns.email, {
        size: 250,
        enablePinning: false,
      }),
      buildColumn<UserDTO>(UserColumns.phoneNumber, {
        size: 150,
        enablePinning: false,
        enableSorting: false,
      }),
      buildColumn<UserDTO>(UserColumns.userType, {
        size: 100,
        enablePinning: false,
        cell: ({ row }) => (
          <span>
            {row.original.UserRoles.map((role) => UserType[role]).join(", ")}
          </span>
        ),
      }),
      buildColumn<UserDTO>(UserColumns.canAssignBookingRequest, {
        size: 120,
        enablePinning: false,
        cell: ({ row }) => (
          <span>{row.original.CanAssignBookingRequest ? "Yes" : "No"}</span>
        ),
      }),
      buildColumn<UserDTO>(UserColumns.createdOn, {
        size: 150,
        enablePinning: false,
        cell: ({ row }) => (
          <span>{formatDate(row.original.CreatedOn, "long")}</span>
        ),
      }),
      buildColumn<UserDTO>(UserColumns.createdBy, {
        size: 150,
        enablePinning: false,
        cell: ({ row }) => <span>{row.original.CreatedByUser}</span>,
      }),
      buildColumn<UserDTO>(UserColumns.updatedOn, {
        size: 200,
        enablePinning: false,
        cell: ({ row }) => (
          <span>
            {row.original.UpdatedOn
              ? formatDate(row.original.UpdatedOn, "long")
              : ""}
          </span>
        ),
      }),
      buildColumn<UserDTO>(UserColumns.updatedBy, {
        size: 150,
        enablePinning: false,
        cell: ({ row }) => <span>{row.original.UpdatedByUser}</span>,
      }),
    ],
    [formatDate, onOpenUser],
  );

  return columns;
};

export { useUserColumns };
